(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pdp-panel-reviews"] && !Shopify.designMode) return;
  try {
    (function () {
    function initReviews() {
      var widget = document.getElementById('bg-reviews-widget');
      if (!widget || widget.getAttribute('data-bg-init')) return;
      widget.setAttribute('data-bg-init', '1');

      var d = widget.dataset;
      var PER_PAGE = 30;
      var MOBILE_CAP = 5;
      var sortBy = 'rating';
      var filterRating = null;
      var currentPage = 1;
      var loaded = false;
      var everAnswered = false;
      var token = 0;
      var capExpanded = false;
      var narrow = window.matchMedia('(max-width: 900px)');
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
      var q = function (sel) { return widget.querySelector(sel); };
      var list = q('.jdgm-rev-widg__reviews');
      var pager = q('.jdgm-paginate');
      var more = q('[data-bg-more]');
      var sortRow = q('[data-bg-sortrow]');
      var hist = q('[data-bg-hist]');
      var main = q('.jdgm-rev-widg__main');
      var starTpl = q('template[data-bg-star-tpl]');
      var form = document.getElementById('bg-review-form');
      var thanks = widget.querySelector('.bg-rvform-thanks');
      var lastOpener = null;

      function shop() { return (window.Shopify && window.Shopify.shop) || location.hostname; }
      function el(tag, cls, text) {
        var e = document.createElement(tag);
        if (cls) e.className = cls;
        if (text != null) e.textContent = text;
        return e;
      }
      function setState(name) {
        ['is-loading', 'is-empty', 'is-ready', 'is-error'].forEach(function (c) { widget.classList.remove(c); });
        widget.classList.add('is-' + name);
      }
      function starRow(rating) {
        var src = starTpl && starTpl.content ? starTpl.content.firstElementChild : null;
        if (!src) return el('span');
        var row = src.cloneNode(true);
        row.style.setProperty('--pdp-fill', Math.max(0, Math.min(5, rating)) * 20 + '%');
        return row;
      }
      function fmtDate(iso) {
        var dt = new Date(iso);
        if (isNaN(dt.getTime())) return '';
        try {
          return new Intl.DateTimeFormat(document.documentElement.lang || 'fr', { day: 'numeric', month: 'long', year: 'numeric' }).format(dt);
        } catch (e) { return ''; }
      }

      function covered() {
        var off = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--bg-header-offset'));
        if (isNaN(off)) {
          var header = document.querySelector('.bg-header');
          off = header ? header.getBoundingClientRect().bottom : 0;
        }
        var bar = document.querySelector('[data-pdp-sticky]');
        if (bar && getComputedStyle(bar).display !== 'none') off += bar.offsetHeight;
        return off;
      }
      function scrollToEl(node) {
        if (!node) return;
        var top = node.getBoundingClientRect().top + window.pageYOffset - covered() - 16;
        window.scrollTo({ top: Math.max(0, top), behavior: reduce.matches ? 'auto' : 'smooth' });
      }

      function renderReview(r) {
        var card = el('article', 'jdgm-rev');
        var head = el('div', 'jdgm-rev__header');
        var rating = parseInt(r.rating, 10) || 0;
        var rate = el('span', 'jdgm-rev__rating');
        rate.appendChild(starRow(rating));
        rate.appendChild(el('span', 'gf-visually-hidden', (d.ratingTpl || '').replace('__R__', rating)));
        head.appendChild(rate);
        var when = fmtDate(r.created_at);
        if (when) {
          var time = el('time', 'jdgm-rev__timestamp', when);
          time.setAttribute('datetime', r.created_at);
          head.appendChild(time);
        }
        card.appendChild(head);
        if (r.title && String(r.title).trim()) card.appendChild(el('h3', 'jdgm-rev__title', String(r.title).trim()));
        var body = el('div', 'jdgm-rev__body');
        body.innerHTML = r.body_html || '';
        card.appendChild(body);

        var replyHtml = r.reply_content || '';
        if (replyHtml.replace(/<[^>]*>/g, ' ').replace(/&nbsp;/g, ' ').trim()) {
          var reply = el('div', 'jdgm-rev__reply');
          var who = (r.shop_reply_name || '').trim();
          var label = who && d.replyBy ? d.replyBy.replace('__NAME__', who) : (d.replyLabel || '');
          if (label) reply.appendChild(el('span', 'bg-jdgm-reply-author', label));
          var replyBody = el('div', 'jdgm-rev__reply-content');
          replyBody.innerHTML = replyHtml;
          reply.appendChild(replyBody);
          card.appendChild(reply);
        }
        card.appendChild(el('p', 'jdgm-rev__author', (r.reviewer_name || '').trim() || d.anonymous || ''));
        return card;
      }

      function renderPager(current, total) {
        pager.innerHTML = '';
        pager.hidden = !(total > 1);
        if (!(total > 1)) return;
        var want = [1, total];
        for (var i = current - 1; i <= current + 1; i++) if (i > 1 && i < total) want.push(i);
        want = want.filter(function (v, k, a) { return a.indexOf(v) === k; }).sort(function (a, b) { return a - b; });
        var add = function (text, page, label, isCurrent) {
          var b = el('button', 'jdgm-paginate__page', text);
          b.type = 'button';
          if (page) b.setAttribute('data-page', page); else b.disabled = true;
          if (label) b.setAttribute('aria-label', label);
          if (isCurrent) { b.setAttribute('aria-current', 'page'); b.disabled = true; }
          pager.appendChild(b);
        };
        add('‹', current > 1 ? current - 1 : null, d.prev);
        var prev = 0;
        want.forEach(function (n) {
          if (prev && n - prev > 1) pager.appendChild(el('span', 'jdgm-paginate__gap', '…'));
          add(String(n), n, (d.pageTpl || '').replace('__N__', n), n === current);
          prev = n;
        });
        add('›', current < total ? current + 1 : null, d.next);
      }

      function applyCap() {
        var capped = narrow.matches && !capExpanded;
        var cards = list.querySelectorAll('.jdgm-rev');
        var over = 0;
        [].forEach.call(cards, function (card, i) {
          var hide = capped && i >= MOBILE_CAP;
          card.hidden = hide;
          if (hide) over++;
        });
        more.hidden = over === 0;
        pager.classList.toggle('is-capped', over > 0);
        if (over > 0) pager.hidden = true;
        else pager.hidden = !pager.children.length;
      }

      function buildHistogram(rows, count) {
        hist.hidden = !count;
        (rows || []).forEach(function (h) {
          var row = hist.querySelector('.jdgm-histogram__row[data-rating="' + h.rating + '"]');
          if (!row) return;
          var freq = parseInt(h.frequency, 10) || 0;
          row.querySelector('.jdgm-histogram__bar-content').style.width = (parseFloat(h.percentage) || 0) + '%';
          row.querySelector('.jdgm-histogram__frequency').textContent = freq;
          row.disabled = !freq && filterRating !== h.rating;
          var star = row.querySelector('.jdgm-histogram__star');
          row.setAttribute('aria-label', (star ? star.textContent : h.rating) + ' : ' + (d.countTpl || '__N__').replace('__N__', freq));
        });
      }

      function updateScore(data, count) {
        var avg = parseFloat(data.average_rating);
        if (!count || !(avg > 0)) return;
        var r = (Math.round(avg * 10) / 10).toFixed(1);
        var score = q('[data-bg-score]');
        if (!score) return;
        score.hidden = false;
        widget.classList.add('has-score');
        var num = score.querySelector('.bg-pdp-score-num');
        if (num && num.firstChild && num.firstChild.nodeType === 3) num.firstChild.nodeValue = r;
        var stars = score.querySelector('.bg-pdp-stars');
        if (stars) stars.style.setProperty('--pdp-fill', parseFloat(r) * 20 + '%');
        var basis = score.querySelector('[data-bg-basis]');
        if (basis && d.basisTpl) basis.textContent = d.basisTpl.replace('__N__', count);
        var sr = score.querySelector('[data-bg-sr]');
        if (sr && d.srTpl) sr.textContent = d.srTpl.replace('__R__', r).replace('__N__', count);
      }

      function syncControls() {
        [].forEach.call(widget.querySelectorAll('[data-sort]'), function (b) {
          var on = b.getAttribute('data-sort') === sortBy;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
        [].forEach.call(hist.querySelectorAll('.jdgm-histogram__row'), function (row) {
          row.setAttribute('aria-pressed', parseInt(row.getAttribute('data-rating'), 10) === filterRating ? 'true' : 'false');
        });
        var clear = hist.querySelector('.jdgm-histogram__clear-filter');
        if (clear) clear.hidden = !filterRating;
      }

      function load(page, scroll) {
        var mine = ++token;
        loaded = true;
        list.setAttribute('aria-busy', 'true');
        var url = 'https://cdn.judge.me/reviews/reviews_for_widget?url=' + encodeURIComponent(shop()) +
          '&shop_domain=' + encodeURIComponent(shop()) +
          '&platform=shopify&page=' + page + '&per_page=' + PER_PAGE +
          '&sort_by=' + encodeURIComponent(sortBy) +
          (filterRating ? '&filter_rating=' + filterRating : '') +
          '&product_id=' + encodeURIComponent(d.id || '');
        fetch(url)
          .then(function (res) { return res.ok ? res.json() : Promise.reject(res.status); })
          .then(function (data) {
            if (mine !== token) return;
            everAnswered = true;
            var reviews = data.reviews || [];
            var count = parseInt(data.number_of_reviews, 10) || 0;
            currentPage = page;
            buildHistogram(data.histogram, count);
            updateScore(data, count);
            list.innerHTML = '';
            list.setAttribute('data-bg-rendered', '1');
            if (!count) {
              setState('empty');
              renderPager(1, 0);
              more.hidden = true;
              syncControls();
              return;
            }
            setState('ready');
            sortRow.hidden = count < 2;
            if (!reviews.length) list.appendChild(el('p', 'bg-jdgm-none', d.filterNone || ''));
            reviews.forEach(function (r) { list.appendChild(renderReview(r)); });
            var pg = data.pagination || {};
            renderPager(pg.current_page || page, pg.total_pages || 1);
            applyCap();
            syncControls();
            if (scroll) scrollToEl(sortRow.hidden ? list : sortRow);
          })
          .catch(function () {
            if (mine !== token) return;
            if (!everAnswered) setState('error');
          })
          .then(function () {
            if (mine === token) list.removeAttribute('aria-busy');
          });
      }

      widget.addEventListener('click', function (e) {
        var t = e.target.closest ? e.target : null;
        if (!t) return;
        var write = t.closest('[data-bg-write]');
        if (write) { e.preventDefault(); openForm(write); return; }
        var retry = t.closest('[data-bg-retry]');
        if (retry) { setState('loading'); load(currentPage, false); return; }
        var moreBtn = t.closest('[data-bg-more]');
        if (moreBtn) {
          capExpanded = true;
          applyCap();
          var next = list.querySelectorAll('.jdgm-rev')[MOBILE_CAP];
          if (next) { next.setAttribute('tabindex', '-1'); next.focus({ preventScroll: true }); }
          return;
        }
        var pageBtn = t.closest('[data-page]');
        if (pageBtn && pager.contains(pageBtn)) {
          var page = parseInt(pageBtn.getAttribute('data-page'), 10);
          if (page && page !== currentPage) load(page, true);
          return;
        }
        var sortBtn = t.closest('[data-sort]');
        if (sortBtn) {
          var s = sortBtn.getAttribute('data-sort');
          if (s === sortBy) return;
          sortBy = s;
          syncControls();
          load(1, true);
          return;
        }
        var row = t.closest('.jdgm-histogram__row, .jdgm-histogram__clear-filter');
        if (row && hist.contains(row)) {
          var raw = row.getAttribute('data-rating');
          var value = raw === 'null' || raw == null ? null : parseInt(raw, 10);
          filterRating = (value === null || value === filterRating) ? null : value;
          syncControls();
          load(1, true);
        }
      });
      if (narrow.addEventListener) narrow.addEventListener('change', applyCap);

      function shown() { return widget.getClientRects().length > 0; }
      var tabsRoot = widget.closest('[data-pdp-tabs]') || document.body;
      var watcher = new MutationObserver(function () {
        if (!loaded && shown()) { watcher.disconnect(); load(1, false); }
      });
      watcher.observe(tabsRoot, { attributes: true, subtree: true, attributeFilter: ['hidden', 'class'] });
      setTimeout(function () {
        if (!loaded && shown()) { watcher.disconnect(); load(1, false); }
      }, 60);

      if (!form) return;
      var rating = 0;
      var starButtons = [].slice.call(form.querySelectorAll('.bg-rvform-star'));
      var fieldOf = {
        name: form.querySelector('#bg-rv-name'),
        email: form.querySelector('#bg-rv-email'),
        title: form.querySelector('#bg-rv-title'),
        body: form.querySelector('#bg-rv-body')
      };
      function showErr(key, message) {
        var box = form.querySelector('[data-rv-err="' + key + '"]');
        if (box) { box.textContent = message || ''; box.hidden = !message; }
        if (fieldOf[key]) {
          if (message) fieldOf[key].setAttribute('aria-invalid', 'true');
          else fieldOf[key].removeAttribute('aria-invalid');
        }
        if (key === 'rating') {
          var group = form.querySelector('.bg-rvform-stars');
          if (message) group.setAttribute('aria-invalid', 'true'); else group.removeAttribute('aria-invalid');
        }
      }
      function clearErrs() { ['rating', 'name', 'email', 'body', 'form'].forEach(function (k) { showErr(k, ''); }); }
      function paintStars(hover) {
        starButtons.forEach(function (b) {
          var v = parseInt(b.getAttribute('data-value'), 10);
          b.setAttribute('aria-checked', v === rating ? 'true' : 'false');
          b.setAttribute('tabindex', v === (rating || 1) ? '0' : '-1');
          b.classList.toggle('is-lit', v <= (hover || rating));
        });
      }
      function setRating(v) { rating = v; paintStars(0); showErr('rating', ''); }
      starButtons.forEach(function (b) {
        var v = parseInt(b.getAttribute('data-value'), 10);
        b.addEventListener('click', function () { setRating(v); });
        b.addEventListener('mouseenter', function () { paintStars(v); });
        b.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight' || e.key === 'ArrowUp') next = Math.min(5, (rating || 0) + 1);
          if (e.key === 'ArrowLeft' || e.key === 'ArrowDown') next = Math.max(1, (rating || 1) - 1);
          if (!next) return;
          e.preventDefault();
          setRating(next);
          starButtons[next - 1].focus();
        });
      });
      form.querySelector('.bg-rvform-stars').addEventListener('mouseleave', function () { paintStars(0); });

      function setExpanded(open) {
        [].forEach.call(widget.querySelectorAll('[data-bg-write]'), function (b) { b.setAttribute('aria-expanded', open ? 'true' : 'false'); });
      }
      function openForm(opener) {
        lastOpener = opener || null;
        form.hidden = false;
        if (thanks) thanks.hidden = true;
        widget.classList.add('is-writing');
        widget.classList.remove('is-sent');
        setExpanded(true);
        scrollToEl(form);
        var first = starButtons[rating ? rating - 1 : 0];
        if (first) first.focus({ preventScroll: true });
      }
      function closeForm(restoreFocus) {
        form.hidden = true;
        clearErrs();
        widget.classList.remove('is-writing');
        setExpanded(false);
        if (restoreFocus && lastOpener && lastOpener.getClientRects().length) lastOpener.focus();
      }
      form.querySelector('[data-rv-cancel]').addEventListener('click', function () { closeForm(true); });

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        clearErrs();
        var name = fieldOf.name.value.trim();
        var email = fieldOf.email.value.trim();
        var body = fieldOf.body.value.trim();
        var bad = null;
        if (!rating) { showErr('rating', d.errRating); bad = bad || starButtons[0]; }
        if (!name) { showErr('name', d.errName); bad = bad || fieldOf.name; }
        if (!/^[^@ ]+@[^@ ]+[.][^@ ]+$/.test(email)) { showErr('email', d.errEmail); bad = bad || fieldOf.email; }
        if (!body) { showErr('body', d.errBody); bad = bad || fieldOf.body; }
        if (bad) { bad.focus(); return; }

        var submit = form.querySelector('.bg-rvform-submit');
        var label = submit.textContent;
        submit.disabled = true;
        submit.textContent = d.sendingText || label;

        var payload = new FormData();
        payload.append('url', shop());
        payload.append('shop_domain', shop());
        payload.append('platform', 'shopify');
        payload.append('id', d.id || '');
        payload.append('rating', rating);
        payload.append('name', name);
        payload.append('email', email);
        payload.append('title', fieldOf.title.value.trim());
        payload.append('body', body);

        fetch('https://api.judge.me/api/v1/reviews', { method: 'POST', body: payload })
          .then(function (res) { if (!res.ok) throw new Error(String(res.status)); })
          .then(function () {
            form.reset();
            rating = 0;
            paintStars(0);
            closeForm(false);
            widget.classList.add('is-sent');
            if (thanks) {
              thanks.hidden = false;
              scrollToEl(thanks);
              thanks.focus({ preventScroll: true });
            }
          })
          .catch(function () { showErr('form', d.errorText); })
          .then(function () {
            submit.disabled = false;
            submit.textContent = label;
          });
      });
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initReviews);
    else initReviews();
    document.addEventListener('shopify:section:load', initReviews);
  })();
  } catch(e) { console.error(e); }
})();

})();
